import { render } from "./RehabilitationForm.vue?vue&type=template&id=72f8b2d5&scoped=true"
import script from "./RehabilitationForm.vue?vue&type=script&lang=js"
export * from "./RehabilitationForm.vue?vue&type=script&lang=js"

import "./RehabilitationForm.vue?vue&type=style&index=0&id=72f8b2d5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72f8b2d5"]])

export default __exports__